export default [
  {
    path: '/vote/',
    component: () => import('@/components/Layer.vue'),
    children: [
      {
        path: '',
        name: 'voteList',
        component: () => import('@/views/Vote/VoteList.vue'),
        meta: {
          prev: 'goHome',
          keepAlive: true
        }
      },
      {
        path: '',
        name: 'voteOption',
        component: () => import('@/views/Vote/VoteOption.vue'),
        children: [
          {
            path: 'voteDetail/:id',
            name: 'voteDetail',
            component: () => import('@/views/Vote/VoteDetail.vue'),
            meta: {
              prev: 'voteList'
            }
          },
          {
            path: 'commentManagement/:id',
            name: 'commentManagement',
            component: () => import('@/views/Vote/CommentManagement.vue'),
            meta: {
              prev: 'voteList'
            }
          }
        ]
      },
      {
        path: '/voteEdit/:id?',
        name: 'voteEdit',
        component: () => import('@/views/Vote/VoteEdit.vue'),
        meta: {
          prev: 'voteList'
        }
      }
    ]
  }
]
